import React from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { Button, Icon, Divider, Modal, theme } from 'components';
import { LayoutContext } from 'contexts';
import DocumentsContext from './DocumentsContext';
import RejectionModal from './RejectionModal';

const DocumentActions: React.FC = () => {
  const { documentId } = useParams<Record<string, string>>();
  const {
    canApproveReject,
    acceptReject,
    print,
    setHistoryOpen,
    documents,
    listing,
    listingAgreement,
  } = React.useContext(DocumentsContext);
  const { isMobileView } = React.useContext(LayoutContext);

  const [rejectionOpen, setRejectionOpen] = React.useState(false);

  const showAcceptReject = () => {
    if (!canApproveReject) return false;
    if (listing.documentStatus !== 'pending') return false;
    if (documentId === 'all') return true;
    return documentId === listingAgreement.id;
  };

  const openHistoryOnClick = () => {
    if (documentId === 'all') {
      return () => setHistoryOpen(listingAgreement.id);
    }
    return () => setHistoryOpen(documentId);
  };

  const acceptHandler = () => Modal.confirm({
      title: `By pressing Accept, you will be publishing this listing to 
      ${
        listing.pendingVisibility === 'network'
          ? 'the Exclusive Network'
          : 'your Brokerage'
      }`,
      onOk: () => acceptReject('accepted'),
      okText: 'Publish',
      cancelText: 'Cancel',
    });

  return (
    <StyledWrapper $isMobileView={isMobileView}>
      <Button
        onClick={openHistoryOnClick()}
        icon={
          <Icon
            type="antdClockCircle"
            color="textPrimary"
            width={14}
            offset={[0, -2]}
          />
        }
      >
        History
      </Button>
      {documentId !== 'all' && (
        <Button
          onClick={() => print(documentId)}
          icon={
            <Icon
              type="antdPrinterOutlined"
              color="textPrimary"
              width={15}
              offset={[0, -2]}
            />
          }
        >
          Print
        </Button>
      )}
      {showAcceptReject() && (
        <>
          {!isMobileView && <StyledDivider type="vertical" />}
          <StyledDangerButton danger onClick={() => setRejectionOpen(true)}>
            Reject
          </StyledDangerButton>
          <Button type="primary" onClick={acceptHandler}>
            Accept
          </Button>
        </>
      )}
      <RejectionModal visible={rejectionOpen} setVisible={setRejectionOpen} />
    </StyledWrapper>
  );
};

const StyledDangerButton = styled(Button)`
  color: ${theme.red8};
  border-color: ${theme.red8};
`;

const StyledWrapper = styled.div<{ $isMobileView: boolean }>`
  display: grid;
  grid-auto-flow: ${({ $isMobileView }) => ($isMobileView ? 'row' : 'column')};
  grid-gap: 10px;
  align-items: center;
`;

const StyledDivider = styled(Divider)`
  height: 25px;
  margin: 0 2px;
`;

export default DocumentActions;
